<template>
  <div class="content">
    <el-dialog v-bind="$attrs" v-on="$listeners" @open="onOpen" title="详情">
      <el-row :gutter="15">
        <el-form
          ref="detailRef"
          :model="dictInfo"
          :rules="rules"
          size="medium"
          label-width="100px"
        >
        <el-col :span="8">
            <el-form-item label="名称" prop="name">
              <el-input
                v-model="dictInfo.name"
                :disabled="true"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="编号" prop="code">
              <el-input
                v-model="dictInfo.code"
                :disabled="true"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="描述" prop="description">
              <el-input
                v-model="dictInfo.description"
                :disabled="true"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="父ID" prop="parentId">
              <el-select
                v-model="dictInfo.parentId"
                :disabled="true"
                placeholder="请选择父id"
                @change="handleChange"
              >
                <el-option
                  v-for="element in parentIdList"
                  :key="element.id"
                  :label="element.name"
                  :value="element.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态" prop="status">
              <el-select
                v-model="dictInfo.status"
                :disabled="true"
                placeholder="请选择状态"
                @change="handleChange"
              >
                <el-option
                  v-for="element in statusList"
                  :key="element.id"
                  :label="element.type"
                  :value="element.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="类型" prop="type">
              <el-input
                v-model="dictInfo.type"
                :disabled="true"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div slot="footer" v-if="false">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handelConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {findAllForSelect}  from '@/api/systemData'
export default {
  props: ["data"],
  data() {
    return {
      parentIdList:[],
      dictInfo: {
        id:"",  
        name:"",  //名称
        code: "",  //编号
        description: "",  //描述
        parentId: "",  //父ID
        status: "",  //状态 0禁用，1启用
        type: "",  //类型
        createUser: "",  //创建人
        createDate: "",  //创建时间
        updateUser: "",  //修改人
        updateDate: "",  //修改日期
      },
      allAppList: [],
      statusList:[
        { id: 1, type: "启用" },
        { id: 0, type: "禁用" },
      ],
      
      rules: {
        role_roleName: [
          {
            required: true,
            message: "名称不能为空",
            trigger: "blur",
          },
        ],
        role_roleCode: [
          {
            required: true,
            message: "编码不能为空",
            trigger: "blur",
          },
        ],
        role_appSystemCode: [
          {
            required: true,
            message: "应用系统编码不能为空",
            trigger: "blur",
          },
        ],
        appSystemName: [
          {
            required: true,
            type: "array",
            message: "请至少选择一个名称",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {
    data: {
      deep: true,
      handler(newData) {
        let newValue = {
          ...newData,
        };
        this.dictInfo = newValue;
      },
    },
  },
  created() {
    this.findAllForSelect();
  },
  mounted() {},
  methods: {
    findAllForSelect(){
      findAllForSelect({}).then((res)=>{
        if(res.code = 10000){
          this.parentIdList = res.data;
        }
      })
    },
    handleChange(value){
      console.log("handleChange-value",value);
    },
    onOpen() {},
    onClose() {
      this.$refs["detailRef"].resetFields();
    },
    close() {
      this.$emit("update:visible", false);
    },
    handelConfirm() {},
  },
};
</script>
<style>
.content {
  background-color: #fff;
  padding: 10px;
}
</style>
